export default {
  base: "16px",
  spacing: "1rem",
  breakpoints: {
    xs: "0em" /* 0px */,
    sm: "30em" /* 480px */,
    md: "64em" /* 1024px */,
    lg: "75em" /* 1200px */,
  },
  typography: {
    font: "'Open Sans', sans-serif",
    text: "1rem",
    title: "2rem",
  },
  colors: {
    light: {},
    dark: {
      "terminal/background": "rgb(17, 36, 47)",
      "terminal/foreground": "rgb(231, 231, 241)",
      "terminal/black": "rgb(17, 36, 47)",
      "terminal/blue": "rgb(88, 157, 226)",
      "terminal/cyan": "rgb(93, 181, 200)",
      "terminal/green": "rgb(94, 169, 101)",
      "terminal/magenta": "rgb(146, 179, 223)",
      "terminal/red": "rgb(229, 101, 103)",
      "terminal/yellow": "rgb(229, 190, 78)",
      "terminal/white": "rgb(154, 180, 194)",
      "terminal/brightBlack": "rgb(17, 36, 47)",
      "terminal/brightBlue": "rgb(88, 157, 226)",
      "terminal/brightCyan": "rgb(93, 181, 200)",
      "terminal/brightGreen": "rgb(94, 169, 101)",
      "terminal/brightMagenta": "rgb(146, 179, 223)",
      "terminal/brightRed": "rgb(229, 101, 103)",
      "terminal/brightWhite": "rgb(231, 231, 241)",
      "terminal/brightYellow": "rgb(229, 190, 78)",
      "terminal/extra-shadow": "rgb(91, 89, 87)",
      "terminal/extra-orange": "rgb(206, 131, 13)",
      "terminal/extra-lightGreen": "rgb(144, 201, 63)",
      "terminal/extra-darkGreen": "rgb(86, 158, 22)",
      "terminal/extra-blue": "rgb(69, 131, 131)",
      "terminal/extra-cyan": "rgb(0, 126, 138)",
      "terminal/extra-error": "rgb(204, 69, 66)",
      "terminal/extra-diffAdd": "rgb(48, 77, 46)",
      "terminal/extra-diffAddFg": "rgb(80, 128, 76)",
      "terminal/extra-diffMod": "rgb(46, 69, 93)",
      "terminal/extra-diffModFg": "rgb(68, 101, 136)",
      "terminal/extra-diffModDark": "rgb(50, 51, 52)",
      "terminal/extra-diffDel": "rgb(83, 50, 50)",
      "terminal/extra-diffDelDark": "rgb(54, 48, 48)",
      "terminal/extra-diffDelFg": "rgb(127, 77, 77)",
      "terminal/extra-white": "rgb(192, 213, 193)",
      "link-primary-600": "rgba(127.93, 171.27, 213.77, 1)",
      "link-secondary-600": "rgba(214, 128, 128, 1)",
      "link-primary-900": "rgba(150.25, 188.7, 227.15, 1)",
      "link-secondary-900": "rgba(227, 151, 151, 1)",
      "colors/primary-100": "rgba(46, 61, 76, 1)",
      "colors/primary-200": "rgba(47.22, 66.05, 85.79, 1)",
      "colors/primary-300": "rgba(47.76, 73.95, 100.14, 1)",
      "colors/primary-400": "rgba(47.76, 73.95, 100.14, 1)",
      "colors/primary-450": "rgba(51.05, 79.05, 107.05, 1)",
      "colors/primary-50": "rgba(50.18, 61.2, 72.22, 1)",
      "colors/primary-500": "rgba(59.7, 92.44, 125.18, 1)",
      "colors/primary-600": "rgba(63.35, 112.02, 161.9, 1)",
      "colors/primary-700": "rgba(100, 151, 201, 1)",
      "colors/primary-800": "rgba(127.93, 171.27, 213.77, 1)",
      "colors/primary-900": "rgba(151, 189, 227, 1)",
      "colors/secondary-100": "rgba(76, 46, 46, 1)",
      "colors/secondary-200": "rgba(85.79, 47.22, 47.22, 1)",
      "colors/secondary-300": "rgba(100.14, 47.76, 47.76, 1)",
      "colors/secondary-400": "rgba(100.14, 47.76, 47.76, 1)",
      "colors/secondary-450": "rgba(107.05, 51.05, 51.05, 1)",
      "colors/secondary-500": "rgba(125.18, 59.7, 59.7, 1)",
      "colors/secondary-600": "rgba(161.9, 63.35, 63.35, 1)",
      "colors/secondary-700": "rgba(201, 100, 100, 1)",
      "colors/secondary-800": "rgba(214, 128, 128, 1)",
      "colors/secondary-900": "rgba(227, 151, 151, 1)",
      "colors/special-bg": "rgba(46, 57, 70, 1)",
      "colors/text-100a": "rgba(240.34, 242.25, 244.16, 0.25)",
      "colors/text-300a": "rgba(240.34, 242.25, 244.16, 0.6499999761581421)",
      "colors/text-300b": "rgba(240.34, 242.25, 244.16, 0.6499999761581421)",
      "colors/text-600a": "rgba(240.34, 242.25, 244.16, 0.800000011920929)",
      "colors/text-600b": "rgba(240.34, 242.25, 244.16, 0.800000011920929)",
      "colors/text-900a": "rgba(240.34, 242.25, 244.16, 1)",
      "colors/text-900b": "rgba(240.34, 242.25, 244.16, 1)",
    },
    colors: {
      light: {},
      dark: {},
    },
  },
};
